import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const PcIllustratedOne = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, value}) => {
  return (
    <div className="illustrated-one-pc" data-model-id="16867:8918">
      <div className="contents">
        <div className="title">
          <p className="heading">Do you relate to the statement below?</p>
        </div>

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/illustrated-one/pc/container.png" alt="Container" className="img" />

          <p className="quote">
            I&#39;m struggling to find the right diet plan.
          </p>
        </div>
      </div>

      <div className="div">
        <button className={`label-wrapper ${value === "no" && "label-wrapper-select"}`} onClick={() => {clickNext("no")}}>
          <div className="label">No</div>
        </button>

         <button className={`label-wrapper ${value === "yes" && "label-wrapper-select"}`} onClick={() => {clickNext("yes")}}>
          <div className="text-wrapper">Yes</div>
        </button>
      </div>
    </div>
  );
};
